<template>
  <div>
    <!-- 弹窗form -->
    <el-drawer
      custom-class="form_drawer"
      :title="drawerTitle"
      size="80%"
      :visible.sync="formShow"
      @closeDrawer="closeDrawer"
      :modal-append-to-body="false"
    >
      <!-- 表单 -->
      <DrawerComponent
        @colse="formShow = false"
        :button="drawerButton"
        :loading="loading"
        @searchData="searchData"
        :drawerConfig="drawerConfig"
      ></DrawerComponent>
    </el-drawer>
    <!-- 导出弹窗 -->
    <ExportModal :propsObj="propsObjInData"></ExportModal>
  </div>
</template>

<script>
import DrawerComponent from '../../../../compoment/drawer-component/drawer-component';
import request from '../../../../../../../found/utils/request';
import * as utils from '../../../../../../../found/utils/index';
import ExportModal from '../../../../../../../found/components/export_modal';

export default {
  name: 'form-component',
  components: {
    DrawerComponent,
    ExportModal,
  },
  data() {
    return {
      id: '',
      loading: false,
      // ---------------------- 弹窗 - 合同新增表单配置
      formShow: false,
      drawerTitle: '查看',
      drawerButton: { show: false },
      drawerConfig: [ // 弹窗组件配置
        {
          title: '基本信息',
          type: 'form',
          ruleForm: {},
          formConfig: { // 弹窗表单配置
            disabled: true,
            items: [
              [{
                label: '单据编号',
                key: 'erpCode',
              }, {
                负责人: '负责人',
                key: 'companyCode',
                show: false,
              }, {
                label: '客户名称',
                key: 'customerName',
              }, {
                label: '公司主体',
                key: 'companyName',
              }, {
                label: '账户金额',
                key: 'accountAmount',
              }, {
                label: '冻结金额',
                key: 'freezeAmount',
              }, {
                label: '可用金额',
                key: 'usableAmount',
              }, {
                label: '包材冻结金额',
                key: 'packageFreezeAmount',
              }, {
                label: '信用金额',
                key: 'creditAmount',
              }, {
                label: '可用信用金额',
                key: 'creditUsableAmount',
              }, {
                label: '客户账户',
                key: 'accountName',
              }, {
                label: '账户状态',
                key: 'customerName',
              }, {
                label: '备注',
                key: 'remarks',
                show: false,
              }],
            ],
          },
        }, {
          title: '资金明细',
          type: 'table',
          tableConfig: {
            rows: [
              {
                label: '编号',
                prop: 'dealCode',
              }, {
                label: '经销商',
                prop: 'customerName',
              }, {
                label: '公司主体',
                prop: 'companyName',
              }, {
                label: '交易类型',
                prop: 'dealType',
              }, {
                label: '期初金额',
                prop: 'initAmount',
              }, {
                label: '交易金额',
                prop: 'dealAmount',
              }, {
                label: '交易账户',
                prop: 'accountName',
              }, {
                label: '期末金额',
                prop: 'endAmount',
              }, {
                label: '修改时间',
                prop: 'updateDate',
              }, {
                label: '创建时间',
                prop: 'createDate',
              },
            ],
          },
          searchConfig: {
            options: [
              {
                valueName: 'dealCode',
                placeholder: '请输入编号',
              }, {
                valueName: 'companyName',
                placeholder: '请输入公司主体',
              }, {
                valueName: 'dealType',
                placeholder: '请输入交易类型',
              }, {
                valueName: 'dealAmount',
                placeholder: '请输入交易金额',
              },
            ],
          },
          tableData: [],
          tableButtons: [
            {
              title: '导出',
              fn: () => {
                this.exportDetail({});
              },
            },
          ],
          pagination: {
            pageNum: 1,
            pageSize: 5,
            pageSizes: [5, 10, 15, 20, 50, 100, 150, 200],
          },
        },
      ],
      propsObjInData: {},
      searchDataExport: {},
    };
  },

  created() {
    this.drawerConfig[0].ruleForm = { ...this.ruleForm };
    this.searchDetail();
  },

  methods: {
    /** @desc 导出按钮 */
    exportDetail() {
      const sid = utils.getUuid(32, 16);
      const params = {
        sid,
        requestUrl: '/dms/captitalPoolController/useInfoPageList',
        functionCode: 'detail_export',
        parentCode: window.App && window.App.$store && window.App.$store.state.menus.selectMenu,
        customerCode: this.ruleForm.customerCode,
        companyCode: this.ruleForm.companyCode,
        ...this.searchDataExport,
      };
      request.post('/excel/excelController/repeatedWriteExport', params).then((res) => {
        if (!res.success) return false;
        this.propsObjInData = {
          functionCode: params.functionCode,
          requestUrl: params.requestUrl,
          visible: true,
          exportMessage: '',
          isExport: true,
          formData: {
            customerCode: this.ruleForm.customerCode,
            companyCode: this.ruleForm.companyCode,
            ...this.searchDataExport,
          },
          sid,
        };
      });
    },
    searchData(val) {
      this.drawerConfig[1].pagination.pageNum = val.pageNum;
      this.drawerConfig[1].pagination.pageSize = val.pageSize;
      this.drawerConfig[1].pagination.pageSizes = [5, 10, 15, 20, 50, 100, 150, 200];
      this.searchDataExport = val || {};
      this.searchDetail(val);
    },
    /**
     * 查询详情
     */
    async searchDetail(val) {
      const { result } = await this.$http.post('/dms/captitalPoolController/useInfoPageList',
        {
          customerCode: this.ruleForm.customerCode,
          companyCode: this.ruleForm.companyCode,
          pageNum: this.drawerConfig[1].pagination.pageNum,
          pageSize: this.drawerConfig[1].pagination.pageSize,
          ...val,
        });
      this.drawerConfig[1].tableData = result.data;
      this.drawerConfig[1].pagination.total = result.count;
    },

    /**
     * 关闭弹窗
     * @param name {string}
     */
    closeDrawer(name) {
      this[name] = false;
    },
  },
};
</script>

<style lang="less" scoped>
.drawer-button {
  padding: 20px 20px;
  text-align: right;
  position: absolute;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  border-top: 1px solid #ebeef5;
}
.drawer-table {
  padding: 20px;
  margin-bottom: 100px;
}
.slot-body {
  display: flex;
  div {
    display: flex;
    align-items: center;
    flex-grow: 2;
    span {
      flex-shrink: 0;
      margin-right: 5px;
    }
    input {
      width: 150px;
    }
  }
}
</style>
